export default __webpack_public_path__ + "static/media/trash.ab8f8a4f.svg";